module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admn-changepassword/admn-changepassword.component.scss
// module id = ./src/app/admn-changepassword/admn-changepassword.component.scss
// module chunks = main